import { lazy } from "react";

const Airport = lazy(() => import("@Icons/Airport"));
const HouseKeeping = lazy(() => import("@Icons/HouseKeeping"));
const PropertyRuleIcon = lazy(() => import("@Icons/PropertyRuleIcon"));
const SimCard = lazy(() => import("@Icons/SimCard"));

const AccommodationFeatures = lazy(() => import("@Icons/AccommodationFeatures"));
const AirConditioning = lazy(() => import("@Icons/AirConditioning"));
const AlarmClock = lazy(() => import("@Icons/AlarmClock"));
const AllBillsIncluded = lazy(() => import("@Icons/AllBillsIncluded"));
const Amphitheater = lazy(() => import("@Icons/Amphitheater"));
const Area = lazy(() => import("@Icons/Area"));
const ArtStudio = lazy(() => import("@Icons/ArtStudio"));
const AtriumIndoor = lazy(() => import("@Icons/AtriumIndoor"));
const Balcony = lazy(() => import("@Icons/Balcony"));
const Barbeque = lazy(() => import("@Icons/Barbeque"));
const Basketball = lazy(() => import("@Icons/Basketball"));
const BeachVolleyball = lazy(() => import("@Icons/BeachVolleyball"));
const BasicEssentials = lazy(() => import("@Icons/BasicEssentials"));
const Bathroom = lazy(() => import("@Icons/Bathroom"));
const BeanBag = lazy(() => import("@Icons/BeanBag"));
const Beds = lazy(() => import("@Icons/Beds"));
const Bicycle = lazy(() => import("@Icons/Bicycle"));
const Blinds = lazy(() => import("@Icons/Blinds"));
const BoatDocks = lazy(() => import("@Icons/BoatDocks"));
const BookShelf = lazy(() => import("@Icons/BookShelf"));
const Bowling = lazy(() => import("@Icons/Bowling"));
const BoxingStudio = lazy(() => import("@Icons/BoxingStudio"));
const BreakfastBar = lazy(() => import("@Icons/BreakfastBar"));
const BusinessCenter = lazy(() => import("@Icons/BusinessCenter"));
const Cabana = lazy(() => import("@Icons/Cabana"));
const Cafe = lazy(() => import("@Icons/Cafe"));
const Chair = lazy(() => import("@Icons/Chair"));
const ChildrenPlayroom = lazy(() => import("@Icons/ChildrenPlayroom"));
const CinemaRoom = lazy(() => import("@Icons/CinemaRoom"));
const Classroom = lazy(() => import("@Icons/Classroom"));
const ClimbingRock = lazy(() => import("@Icons/ClimbingRock"));
const CityRelocation = lazy(() => import("@Icons/CityRelocation"));
const Clubhouse = lazy(() => import("@Icons/Clubhouse"));
const CoffeeBar = lazy(() => import("@Icons/CoffeeBar"));
// const CommonSocialArea = lazy(() => import("@Icons/CommonSocialArea"));
const ConferenceRoom = lazy(() => import("@Icons/ConferenceRoom"));
const ContentInsurance = lazy(() => import("@Icons/ContentInsurance"));
const ControlledAccess = lazy(() => import("@Icons/ControlledAccess"));
const Courtyard = lazy(() => import("@Icons/Courtyard"));
const CoveredParking = lazy(() => import("@Icons/CoveredParking"));
const Den = lazy(() => import("@Icons/Den"));
const Desk = lazy(() => import("@Icons/Desk"));
const DiningArea = lazy(() => import("@Icons/DiningArea"));
const Drawer = lazy(() => import("@Icons/Drawer"));
const DisabilityAccess = lazy(() => import("@Icons/DisabilityAccess"));
const Doorman = lazy(() => import("@Icons/Doorman"));
const DryCleaning = lazy(() => import("@Icons/DryCleaning"));
const DualOccupancy = lazy(() => import("@Icons/DualOccupancy"));
const ElectricVehicleChargingStations = lazy(
  () => import("@Icons/ElectricVehicleChargingStations"),
);
const Electricity = lazy(() => import("@Icons/Electricity"));
const ElectronicPayment = lazy(() => import("@Icons/ElectronicPayment"));
const Elevator = lazy(() => import("@Icons/Elevator"));
const ExhaustFan = lazy(() => import("@Icons/ExhaustFan"));
const Finances = lazy(() => import("@Icons/Finances"));
const FireExtinguisher = lazy(() => import("@Icons/FireExtinguisher"));
const Fireplace = lazy(() => import("@Icons/Fireplace"));
const Flatmate = lazy(() => import("@Icons/Flatmate"));
const FlooringTile = lazy(() => import("@Icons/FlooringTile"));
const Food = lazy(() => import("@Icons/Food"));
const Football = lazy(() => import("@Icons/Football"));
const Fridge = lazy(() => import("@Icons/Fridge"));
const FullyFurnished = lazy(() => import("@Icons/FullyFurnished"));
const GamesArea = lazy(() => import("@Icons/GamesArea"));
const Garage = lazy(() => import("@Icons/Garage"));
const Garden = lazy(() => import("@Icons/Garden"));
const Gas = lazy(() => import("@Icons/Gas"));
const GolfSimulator = lazy(() => import("@Icons/GolfSimulator"));
const GuarantorRequirement = lazy(() => import("@Icons/GuarantorRequirement"));
const Gym = lazy(() => import("@Icons/Gym"));
const Heating = lazy(() => import("@Icons/Heating"));
const HomeLinen = lazy(() => import("@Icons/HomeLinen"));
const HotTub = lazy(() => import("@Icons/HotTub"));
const HouseholdSupplies = lazy(() => import("@Icons/HouseholdSupplies"));
const IndustryAccreditationAwards = lazy(() => import("@Icons/IndustryAccreditation&Awards"));
const IroningFacility = lazy(() => import("@Icons/IroningFacility"));
const JoggingTrail = lazy(() => import("@Icons/JoggingTrail"));
const Karaoke = lazy(() => import("@Icons/Karaoke"));
const Kitchen = lazy(() => import("@Icons/Kitchen"));
const Lamp = lazy(() => import("@Icons/Lamp"));
const Laundry = lazy(() => import("@Icons/Laundry"));
const Library = lazy(() => import("@Icons/Library"));
const LocationBenefit = lazy(() => import("@Icons/LocationBenefit"));
const LockerSafes = lazy(() => import("@Icons/LockerSafes"));
const Lounge = lazy(() => import("@Icons/Lounge"));
const MailRoom = lazy(() => import("@Icons/MailRoom"));
const Maintenance = lazy(() => import("@Icons/Maintenance"));
const Mattress = lazy(() => import("@Icons/Mattress"));
const Microwave = lazy(() => import("@Icons/Microwave"));
const MedicalFacilities = lazy(() => import("@Icons/MedicalFacilities"));
const Mirror = lazy(() => import("@Icons/Mirror"));
const Music = lazy(() => import("@Icons/Music"));
const Noticeboard = lazy(() => import("@Icons/Noticeboard"));
const Oven = lazy(() => import("@Icons/Oven"));
const Parking = lazy(() => import("@Icons/Parking"));
const Patio = lazy(() => import("@Icons/Patio"));
const PC = lazy(() => import("@Icons/PC"));
const Pest = lazy(() => import("@Icons/Pest"));
const Pet = lazy(() => import("@Icons/Pet"));
const PetFriendly = lazy(() => import("@Icons/PetFriendly"));
const PetsNotAllowed = lazy(() => import("@Icons/PetsNotAllowed"));
// const Phone = lazy(() => import("@Icons/Phone"));
const Piano = lazy(() => import("@Icons/Piano"));
const Picnic = lazy(() => import("@Icons/Picnic"));
const Playground = lazy(() => import("@Icons/Playground"));
const Poker = lazy(() => import("@Icons/Poker"));
const PrayerRoom = lazy(() => import("@Icons/PrayerRoom"));
const Racquetball = lazy(() => import("@Icons/Racquetball"));
const ReceptionStaff = lazy(() => import("@Icons/ReceptionStaff"));
const RentalCar = lazy(() => import("@Icons/RentalCar"));
const RoomStorage = lazy(() => import("@Icons/RoomStorage"));
const Sauna = lazy(() => import("@Icons/Sauna"));
const Security = lazy(() => import("@Icons/Security"));
const Shield = lazy(() => import("@Icons/Shield"));
const Shops = lazy(() => import("@Icons/Shops"));
const ShowerRoom = lazy(() => import("@Icons/ShowerRoom"));
const ShuttleCab = lazy(() => import("@Icons/ShuttleCab"));
const SingleOccupancy = lazy(() => import("@Icons/SingleOccupancy"));
const SnookerTable = lazy(() => import("@Icons/SnookerTable"));
const SnowRemoval = lazy(() => import("@Icons/SnowRemoval"));
const SocialEvents = lazy(() => import("@Icons/SocialEvents"));
const SpinningBike = lazy(() => import("@Icons/SpinningBike"));
const Spa = lazy(() => import("@Icons/Spa"));
const Sports = lazy(() => import("@Icons/Sports"));
const Sundeck = lazy(() => import("@Icons/Sundeck"));
const SwimmingPool = lazy(() => import("@Icons/SwimmingPool"));
const Table = lazy(() => import("@Icons/Table"));
const TeaBar = lazy(() => import("@Icons/TeaBar"));
const Television = lazy(() => import("@Icons/Television"));
const Theater = lazy(() => import("@Icons/Theater"));
const Tennis = lazy(() => import("@Icons/Tennis"));
const Terrace = lazy(() => import("@Icons/Terrace"));
const Trash = lazy(() => import("@Icons/Trash"));
const UnfurnishedAccommodations = lazy(() => import("@Icons/UnfurnishedAccommodations"));
const VacuumCleaner = lazy(() => import("@Icons/VacuumCleaner"));
const ValetParking = lazy(() => import("@Icons/ValetParking"));
const VendingMachine = lazy(() => import("@Icons/VendingMachine"));
const VideoIntercom = lazy(() => import("@Icons/VideoIntercom"));
const VoiceIntercom = lazy(() => import("@Icons/VoiceIntercom"));
const Wardrobe = lazy(() => import("@Icons/Wardrobe"));
const Water = lazy(() => import("@Icons/Water"));
const Wellness = lazy(() => import("@Icons/Wellness"));
const Wheel = lazy(() => import("@Icons/Wheel"));
const Wifi = lazy(() => import("@Icons/Wifi"));
const WineTasting = lazy(() => import("@Icons/WineTasting"));
const YogaStudio = lazy(() => import("@Icons/YogaStudio"));

const SharedRoomIcon = lazy(() => import("@Icons/SharedRoomNoBgIcon"));
const PayInInstalmentsIcon = lazy(() => import("@Icons/PayInInstalmentsIcon"));
const NoVisaNoPayIcon = lazy(() => import("@Icons/NoVisaNoPayIcon"));

const OneBIcon = lazy(() => import("@Icons/OneBNoBgIcon"));
const TwoBIcon = lazy(() => import("@Icons/TwoBNoBgIcon"));
const ThreeBIcon = lazy(() => import("@Icons/ThreeBNoBgIcon"));
const FourBIcon = lazy(() => import("@Icons/FourBNoBgIcon"));
const StudioIcon = lazy(() => import("@Icons/StudioNoBgIcon"));
const EnsuiteIcon = lazy(() => import("@Icons/EnsuiteNoBgIcon"));
const NonEnsuite = lazy(() => import("@Icons/NonEnsuiteNoBgIcon"));

// A constant, not a factory: callers looked it up per tag, building ~250 elements each time.
// A named export: verify-wrapper-hoc rejects a bare default export that is not a component.
// eslint-disable-next-line import/prefer-default-export
export const iconNameMap = {
  // ─── Room Types ───
  twin_studio: <StudioIcon />,
  twin_ensuite: <EnsuiteIcon />,
  ensuite: <EnsuiteIcon />,
  non_ensuite: <NonEnsuite />,
  shared_room: <SharedRoomIcon />,
  "1b": <OneBIcon />,
  "2b": <TwoBIcon />,
  "3b": <ThreeBIcon />,
  "4b": <FourBIcon />,
  "5b": <FourBIcon />,

  // ─── Fitness & Recreation (L1) ───
  // L2: Gym & Fitness
  gym: <Gym />,
  fitness: <Gym />,
  // L2: Spa & Salon
  spa: <Spa />,
  salon: <Spa />,
  // L2: Sports
  sports: <Sports />,
  // L2: Wine Tasting Room
  wine: <WineTasting />,
  tasting: <WineTasting />,
  // L2: Heated Lap Pool
  heated: <SwimmingPool />,
  lap: <SwimmingPool />,
  // L2: Snooker Table
  snooker: <SnookerTable />,
  // L2: Beach Volleyball
  beach: <BeachVolleyball />,
  volleyball: <BeachVolleyball />,
  // L2: Spinning Bike
  spinning: <SpinningBike />,
  // L2: Indoor Atrium
  atrium: <AtriumIndoor />,
  indoor: <AtriumIndoor />,
  // L2: Rock Climbing Wall
  climbing: <ClimbingRock />,
  rock: <ClimbingRock />,
  // L2: Golf Simulator
  golf: <GolfSimulator />,
  simulator: <GolfSimulator />,
  // L2: Coffee Bar
  coffee: <CoffeeBar />,
  // L2: Boxing Studio
  boxing: <BoxingStudio />,
  // L2: Tea Bar
  tea: <TeaBar />,
  // L2: Karaoke Room
  karaoke: <Karaoke />,
  // L2: Table Football
  football: <Football />,
  table: <Table />,
  // L2: Outdoor Amphitheater
  amphitheater: <Amphitheater />,
  // L2: Wellness Centre
  wellness: <Wellness />,
  // L2: PC Room
  pc: <PC />,
  // L2: Bowling
  bowling: <Bowling />,
  // L2: Racquetball Room
  racquetball: <Racquetball />,
  // L2: Poker Room
  poker: <Poker />,
  // L2: Tennis Court
  tennis: <Tennis />,
  court: <Sports />,
  // L2: Swimming Pool
  swimming: <SwimmingPool />,
  pool: <SwimmingPool />,
  // L2: Club House
  clubhouse: <Clubhouse />,
  club: <Clubhouse />,
  // L2: Pool Table
  // billiard: <GamesArea />,
  // L2: Volleyball Court (covered by volleyball/court above)
  // L2: Table Tennis
  // ping: <Ball />,
  // pong: <Ball />,
  // L2: Game Room
  games: <GamesArea />,
  game: <GamesArea />,
  // L2: Yoga Studio
  yoga: <YogaStudio />,
  // L2: Tanning Bed
  tanning: <Gym />,
  // L2: Basketball Court
  basketball: <Basketball />,
  // L2: Dance Room
  // dance: <Gym />,
  // L2: Spa Rooms
  // (covered by spa above)
  // L2: Sauna Room
  sauna: <Sauna />,
  // L2: Music Studio
  music: <Music />,
  // L2: Art Studio
  art: <ArtStudio />,
  // L2: Theater
  theater: <Theater />,
  theatre: <Theater />,
  // L2: Public Piano
  piano: <Piano />,

  // ─── Parking (L1) ───
  // L2: Parking
  parking: <Parking />,
  // L2: Electric Vehicle Charging Station
  charging: <ElectricVehicleChargingStations />,
  electric: <ElectricVehicleChargingStations />,
  // L2: Garage
  garage: <Garage />,
  // L2: Street Parking
  street: <Parking />,
  // L2: Covered Parking
  covered: <CoveredParking />,
  // L2: Surface Parking Lot
  // surface: <Parking />,
  // lot: <Parking />,

  // ─── Shared Community & Utilities (L1) ───
  // L2: Cafe & Restaurant
  cafe: <Cafe />,
  restaurant: <Cafe />,
  // L2: Cinema Room
  cinema: <CinemaRoom />,
  entertainment: <CinemaRoom />,
  // L2: Clubhouse (covered above)
  // L2: Prayer Room
  prayer: <PrayerRoom />,
  // L2: Library & Study Area
  library: <Library />,
  study: <Desk />,
  // L2: Lounge
  lounge: <Lounge />,
  // L2: Common Social Area
  social: <SocialEvents />,
  // L2: Games Area (covered above)
  // L2: Vending Machine
  vending: <VendingMachine />,
  // L2: Noticeboard
  noticeboard: <Noticeboard />,
  // L2: Classroom
  classroom: <Classroom />,
  // L2: Den
  den: <Den />,
  // L2: Breakfast Bar
  breakfast: <BreakfastBar />,
  // L2: Dining Area
  dining: <DiningArea />,
  // L2: Free Printing
  printing: <BusinessCenter />,
  // L2: Communal Kitchen
  communal: <Kitchen />,
  // L2: Pet Washroom
  washroom: <PetFriendly />,
  // L2: Wi-Fi
  wifi: <Wifi />,
  broadband: <Wifi />,
  internet: <Wifi />,
  // L2: Mailroom
  mailroom: <MailRoom />,
  mail: <MailRoom />,
  // L2: Dining Hall
  hall: <Garage />,
  // L2: Trash Room
  trash: <Trash />,
  // L2: Package Locker
  package: <ControlledAccess />,
  // L2: Study Room (covered by study above)
  // L2: Conference Room
  conference: <ConferenceRoom />,
  // L2: Children's Playroom
  children: <ChildrenPlayroom />,
  playroom: <ChildrenPlayroom />,
  // L2: On-site Retail
  retail: <Shops />,
  "on-site": <ReceptionStaff />,
  onsite: <ReceptionStaff />,
  site: <ReceptionStaff />,
  // L2: Lobby
  lobby: <Elevator />,
  // L2: Elevator
  elevator: <Elevator />,
  // L2: Laundry Room
  laundry: <Laundry />,
  // L2: EV Charging Stations (covered by charging/electric above)
  ev: <ElectricVehicleChargingStations />,
  // L2: Library (covered above)
  // L2: Storage
  storage: <RoomStorage />,
  // L2: Bike Storage
  bike: <SpinningBike />,
  // L2: Business Center
  business: <BusinessCenter />,
  // L2: Pet Park
  pet: <Pet />,

  // ─── Property Services (L1) ───
  // L2: Maintenance
  maintenance: <Maintenance />,
  // L2: Garbage Disposal
  garbage: <Trash />,
  disposal: <Trash />,
  // L2: Laundry Facility (covered by laundry above)
  // L2: Snow Removal
  snow: <SnowRemoval />,
  removal: <SnowRemoval />,
  // L2: Parcel Collection
  parcel: <MailRoom />,
  post: <MailRoom />,
  // L2: Shuttle & Cab Service
  shuttle: <ShuttleCab />,
  cab: <ShuttleCab />,
  // L2: Electronic Payments
  payments: <ElectronicPayment />,
  electronic: <ElectronicPayment />,
  // L2: Guarantor Requirement
  guarantor: <GuarantorRequirement />,
  // L2: Common Service
  common: <Maintenance />,
  // L2: Location Benefit
  location: <LocationBenefit />,
  // L2: Shops
  shops: <Shops />,
  // L2: Delivery Alert System
  delivery: <MailRoom />,
  alert: <MailRoom />,
  // L2: Dry Cleaning Service
  dry: <DryCleaning />,
  cleaning: <DryCleaning />,
  // L2: Reception
  reception: <ReceptionStaff />,
  staff: <ReceptionStaff />,
  // L2: Free SIM Card
  sim: <SimCard />,
  // L2: Social Events
  events: <SocialEvents />,
  // L2: Pest Control
  pest: <Pest />,
  // L2: Valet Parking
  valet: <ValetParking />,
  // L2: Rental Car
  rental: <RentalCar />,
  // L2: Housekeeping
  housekeeping: <HouseKeeping />,
  // L2: Airport Pickup
  airport: <Airport />,
  pickup: <Airport />,
  // L2: City Relocation
  relocation: <CityRelocation />,
  // L2: Free Bicycle Rental
  bicycle: <Bicycle />,
  // L2: On-site Maintenance Team (covered by on-site/maintenance above)
  // L2: Package Room (covered by package above)

  // ─── Security (L1) ───
  // L2: Disability Access
  disability: <DisabilityAccess />,
  wheelchair: <DisabilityAccess />,
  // L2: Fire Extinguisher
  extinguisher: <FireExtinguisher />,
  // L2: Locker & Safes
  locker: <LockerSafes />,
  safes: <LockerSafes />,
  // L2: Reception & Staff (covered above)
  // L2: Property Rules
  property: <PropertyRuleIcon />,
  rules: <PropertyRuleIcon />,
  // L2: Content Insurance
  insurance: <ContentInsurance />,
  content: <ContentInsurance />,
  // L2: Medical Facility
  medical: <MedicalFacilities />,
  // L2: 24 Hours Security
  "24": <Shield />,
  hours: <Shield />,
  security: <Shield />,
  // L2: CCTV
  cctv: <Security />,
  // L2: Fire System
  fire: <FireExtinguisher />,
  // L2: Doorman
  doorman: <Doorman />,
  // L2: Video Surveillance
  surveillance: <Security />,
  // L2: Controlled Access
  controlled: <ControlledAccess />,
  access: <ControlledAccess />,
  // L2: Virtual Doorman
  virtual: <Security />,
  // L2: Security Guard
  guard: <Doorman />,
  // L2: Voice Intercom System
  intercom: <VoiceIntercom />,
  voice: <VoiceIntercom />,
  // L2: Video Intercom System
  video: <VideoIntercom />,
  // L2: Elevator Access Control (covered by elevator/access above)
  secure: <Shield />,

  // ─── Outdoor Activities (L1) ───
  // L2: Jogging
  jogging: <JoggingTrail />,
  // L2: Playground
  playground: <Playground />,
  // L2: Sport Golf (covered by golf above)
  // L2: Swimming Pool (covered above)
  // L2: Terrace
  terrace: <Terrace />,
  // L2: Barbeque & Grill
  barbeque: <Barbeque />,
  grill: <Barbeque />,
  bbq: <Barbeque />,
  // L2: Balcony or Patios
  balcony: <Balcony />,
  patios: <Patio />,
  patio: <Patio />,
  // L2: Picnic Area
  picnic: <Picnic />,
  // L2: Courtyard
  courtyard: <Courtyard />,
  outdoor: <Courtyard />,
  // L2: Balcony (covered above)
  // L2: Boat Docks
  boat: <BoatDocks />,
  docks: <BoatDocks />,
  // L2: Cabana
  cabana: <Cabana />,
  // L2: Sundeck
  sundeck: <Sundeck />,
  // L2: Outdoor Kitchen
  // (covered by outdoor/kitchen)
  // L2: Outdoor Lounge
  // (covered by outdoor/lounge)
  // L2: Patio (covered above)
  // L2: Hot Tub
  hot: <HotTub />,
  tub: <HotTub />,
  jacuzzi: <HotTub />,
  // L2: Rooftop
  rooftop: <Terrace />,
  // L2: Outdoor Grilling Area
  grilling: <Barbeque />,

  // ─── Room Features & Furnishing ───
  kitchen: <Kitchen />,
  kitchens: <Kitchen />,
  cooktop: <Kitchen />,
  television: <Television />,
  bed: <Beds />,
  bedrooms: <Beds />,
  shower: <ShowerRoom />,
  mirror: <Mirror />,
  mirrors: <Mirror />,
  drawer: <Drawer />,
  drawers: <Drawer />,
  shelving: <BookShelf />,
  bathroom: <Bathroom />,
  bathrooms: <Bathroom />,
  conditioning: <AirConditioning />,
  air: <AirConditioning />,
  cooling: <AirConditioning />,
  fridge: <Fridge />,
  freezer: <Fridge />,
  wardrobe: <Wardrobe />,
  microwave: <Microwave />,
  oven: <Oven />,
  desk: <Desk />,
  chair: <Chair />,
  chairs: <Chair />,
  lamp: <Lamp />,
  tv: <Television />,
  tvs: <Television />,
  space: <Television />,
  fan: <ExhaustFan />,
  fireplace: <Fireplace />,
  tile: <FlooringTile />,
  bean: <BeanBag />,
  mattress: <Mattress />,
  blinds: <Blinds />,
  vacuum: <VacuumCleaner />,
  vaccum: <VacuumCleaner />,
  telephone: <VoiceIntercom />,
  area: <Area />,
  garden: <Garden />,

  // ─── Bills & Utilities ───
  electricity: <Electricity />,
  heating: <Heating />,
  water: <Water />,
  gas: <Gas />,
  bills: <AllBillsIncluded />,

  // ─── Accommodation & General ───
  accommodation: <AccommodationFeatures />,
  furnished: <FullyFurnished />,
  unfurnished: <UnfurnishedAccommodations />,
  double: <DualOccupancy />,
  dual: <DualOccupancy />,
  deposit: <Finances />,
  deposits: <Finances />,
  team: <Finances />,
  essentials: <BasicEssentials />,
  alarm: <AlarmClock />,
  flatmate: <Flatmate />,
  ironing: <IroningFacility />,
  household: <HouseholdSupplies />,
  linen: <HomeLinen />,
  awards: <IndustryAccreditationAwards />,
  pets: <PetsNotAllowed />,
  food: <Food />,
  meals: <Food />,
  room: <SingleOccupancy />,
  floor: <FlooringTile />,
  wheel: <Wheel />,
  studio: <StudioIcon />,

  // ─── Payment Tags ───
  instalment: <PayInInstalmentsIcon />,
  instalments: <PayInInstalmentsIcon />,
  installment: <PayInInstalmentsIcon />,
  installments: <PayInInstalmentsIcon />,
  visa: <NoVisaNoPayIcon />,
};
